import cx from "classnames";
import React from "react";

import { HERO_MAIN_ID_CONTAINER } from "../../../constants";
import { Styles, withStyles } from "./styles";

export interface IBasicHeaderProps extends Styles {
  withResume?: boolean;
}

const BasicHeader: React.FC<IBasicHeaderProps> = ({
  classes,
  children,
  withBreadcrumbs,
  withResume
}) => (
  <div
    className={cx(classes.header, {
      [classes.withResume]: withResume,
      [classes.withBreadcrumbs]: withBreadcrumbs
    })}
    data-id={HERO_MAIN_ID_CONTAINER}
  >
    {children}
  </div>
);

export const Header = withStyles(BasicHeader);
